var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.home) ? _c('div', {
    staticClass: "header",
    class: {
      'expanded': _vm.menuExpanded, 'reduced': _vm.reducedMenu
    }
  }, [_c('div', {
    staticClass: "header__inner"
  }, [(_vm.page.home.logo) ? _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.page.home.logo.img.$src,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "burger",
    on: {
      "click": function($event) {
        _vm.expandMenu()
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "navigation-container"
  }, [(_vm.page.home.logo) ? _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.page.home.logo.img.$src,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('span', {
    staticClass: "navigation__close",
    on: {
      "click": function($event) {
        _vm.expandMenu()
      }
    }
  }, [_vm._v("×")])], 1), _vm._v(" "), _c('Langs')], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cb51fb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderComponent.vue
// module id = 184
// module chunks = 0